export let GALLERY_EVENTS = /*#__PURE__*/function (GALLERY_EVENTS) {
  GALLERY_EVENTS["APP_LOADED"] = "APP_LOADED";
  GALLERY_EVENTS["GALLERY_CHANGE"] = "GALLERY_CHANGE";
  GALLERY_EVENTS["NEED_MORE_ITEMS"] = "NEED_MORE_ITEMS";
  GALLERY_EVENTS["ITEM_ACTION_TRIGGERED"] = "ITEM_ACTION_TRIGGERED";
  GALLERY_EVENTS["LOAD_MORE_CLICKED"] = "LOAD_MORE_CLICKED";
  GALLERY_EVENTS["NAVIGATION_API_READY"] = "NAVIGATION_API_READY";
  GALLERY_EVENTS["CURRENT_ITEM_CHANGED"] = "CURRENT_ITEM_CHANGED";
  GALLERY_EVENTS["ON_ITEM_CLICKED"] = "ON_ITEM_CLICKED";
  return GALLERY_EVENTS;
}({});
//# sourceMappingURL=events.js.map